import { Skeleton } from "@/components/ui/skeleton"
import { CompraUsuarioDto } from "@/dtos/CompraUsuarioDto"
import CompraService from "@/services/CompraService"
import { useEffect, useState } from "react"
import CardCompras from "@/components/CardCompras";
import ModalImagemTitulo from "@/components/ModalImagemTitulo";
import { useAuth } from "@/contexts/AuthProvider";
import { useNavigate } from "react-router-dom";

export function UltimasCompras() {
    const [compras, setCompras] = useState<CompraUsuarioDto[]>([]);
    const [loading, setLoading] = useState(true);
    const [exibirModal, setExibirModal] = useState<boolean>(false);
    const [imagensTitulo, setImagensTitulo] = useState<string[]>([]);
    const { isAuthorized, realizarLoginPorToken, usuario } = useAuth();
    const urlParams = new URLSearchParams(window.location.search);
    const tokenFromUrl = urlParams.get('token');
    const isAndroid = navigator.userAgent.toLowerCase().includes("android");
    const isInstagram = navigator.userAgent.toLowerCase().includes("instagram")
    const navigate = useNavigate();

    useEffect(() => {
        if (isInstagram && isAndroid) {
            const link = document.createElement('a');
            link.href = `${window.location.href}?token=${encodeURIComponent(tokenFromUrl || usuario?.TokenAcesso!)}`;
            link.target = '_blank';
            link.download = '';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }

        if (!isAuthorized) {
            if (!tokenFromUrl) {
                navigate('/')
                return;
            }

            realizarLoginPorToken(tokenFromUrl!);
        }

        buscarCompras();
    }, [])

    useEffect(() => {
        if (exibirModal === false) {
            setTimeout(() => {
                setImagensTitulo([]);
            }, 500)
        }
    }, [exibirModal])

    async function buscarCompras() {
        try {
            const result = await CompraService.BuscarTodasComprasPorUsuarioCompleto(tokenFromUrl);
            setCompras(result.Data.Compras);
        } catch (error) {

        } finally {
            setLoading(false);
        }
    }

    function toggleModal() {
        setExibirModal(!exibirModal);
    }

    return (
        <>

            <ModalImagemTitulo
                imgs={imagensTitulo}
                toggleModal={toggleModal}
                exibirModal={exibirModal}
            />

            {
                loading ? (
                    <>
                        <div className="hidden md:flex-col md:flex">
                            <div className="flex items-center gap-4 mb-5 flex-wrap mt-10">
                                <Skeleton className="h-60 w-60 md:basis-1/5" />
                                <Skeleton className="h-60 w-60 md:basis-1/5" />
                                <Skeleton className="h-60 w-60 md:basis-1/5" />
                                <Skeleton className="h-60 w-60 md:basis-1/5" />
                            </div>
                            <div className="flex items-center gap-4 mb-5 flex-wrap mt-10">
                                <Skeleton className="h-60 w-60 md:basis-1/5" />
                                <Skeleton className="h-60 w-60 md:basis-1/5" />
                                <Skeleton className="h-60 w-60 md:basis-1/5" />
                                <Skeleton className="h-60 w-60 md:basis-1/5" />
                            </div>
                            <div className="flex items-center gap-4 mb-5 flex-wrap mt-10">
                                <Skeleton className="h-60 w-60 md:basis-1/5" />
                                <Skeleton className="h-60 w-60 md:basis-1/5" />
                                <Skeleton className="h-60 w-60 md:basis-1/5" />
                                <Skeleton className="h-60 w-60 md:basis-1/5" />
                            </div>
                        </div>
                        <div className="md:hidden">
                            <div className="flex items-center self-center justify-center gap-4 mb-5 flex-wrap mt-10">
                                <Skeleton className="h-60 w-[80%]" />
                                <Skeleton className="h-60 w-[80%]" />
                                <Skeleton className="h-60 w-[80%]" />
                                <Skeleton className="h-60 w-[80%]" />
                            </div>
                        </div>
                    </>) : (
                    <>
                        <div className="mx-4 flex-col">
                            <h2 className="text-primary-foreground font-bold text-2xl">Ultimas Compras</h2>
                            <p>Confira seu histórico de compras</p>

                            <div className="flex flex-wrap gap-4 justify-center my-5">
                                {
                                    compras?.map((compra) => {
                                        return (
                                            <CardCompras key={compra.IdCompra} compra={compra} />
                                        )
                                    })
                                }

                                {
                                    compras.length === 0 && (
                                        <div className="flex flex-col items-center justify-center mb-20">
                                            <p className="text-primary-foreground text-xl">Nenhuma compra encontrada</p>
                                        </div>
                                    )
                                }
                            </div>

                        </div>
                    </>
                )
            }
        </>
    )


}